import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filter", "item"]

  filter(event) {
    const category = event.currentTarget.dataset.category

    this.filterTargets.forEach((btn) => {
      btn.classList.toggle("wp-faqs-filter--active", btn === event.currentTarget)
    })

    this.itemTargets.forEach((item) => {
      const matches = category === "all" || item.dataset.category === category
      item.hidden = !matches
      if (!matches) item.classList.remove("ex-faq-item--open")
    })
  }
}
